//Runs BEFORE the app loads (it is the first import in index.js): a visit to an event alias
//such as /bsm becomes /bsm2026 with the same ?query and #anchor, by replacing the address in
//place (no reload, no extra history entry). Doing it this early means everything that reads
//the address while starting up already sees the real page: Google Analytics' first
//pageview (App.tsx, at import time), the "return here after sign-in" address (beforeLogin)
//and the deep-link loader (PageViewer). The list lives in
//components/pageBuilder/viewer/pageAliases.js; clicks inside the app are handled in PageViewer.
import { aliasRedirectTarget } from './components/pageBuilder/viewer/pageAliases';

const target = aliasRedirectTarget(window.location);
if (target) window.history.replaceState(window.history.state, '', target);
